<style>
.third {
  border-color: #0057f9;
  color: #fff;
  box-shadow: 0 0 40px 40px #0042d1 inset, 0 0 0 0 #0137e7;
  -webkit-transition: all 150ms ease-in-out;
  transition: all 150ms ease-in-out;
}

.third:hover {
  box-shadow: 0 0 10px 0 #0089f9 inset, 0 0 10px 4px #0081f9;
  color: rgb(0, 0, 0);
}

.acordeon {
  overflow: hidden;
  transition: max-height 0.5s ease;
  max-height: 0;
}
</style>
<template>
  <div>
    <div class="content-box" style="padding: 0rem 0.4rem">
      <div class="row">
        <div class="col-12">
          <div class="element-box">
            <div>
              <router-link class="btn btn-sm btn-outline-link" :to="{ name: 'pos-pedidos-mayoreo' }">
                <i class="fas fa-angle-left"></i>
                Regresar
              </router-link>
              <div style="text-align: right;">
                <div class="btn-group">
                  <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                    data-toggle="dropdown" type="button">
                    <i class="fa fa-cogs"></i>
                    Acciones
                  </button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <button class="dropdown-item" :class="{ disabled: !(current.estado == 'B') }" @click="abrir"
                      :disabled="!(current.estado == 'B')" href="#">
                      <i class="fa fa-unlock"></i>
                      Abrir Operación
                    </button>
                    <button class="dropdown-item" @click="cerrar" :disabled="!(current.estado == 'A')" href="#">
                      <i class="fa fa-lock"></i>
                      Cerrar Operación
                    </button>
                    <button class="dropdown-item" @click="enviar_picking" :disabled="!(current.estado == 'B')" href="#">
                      <i class="fas fa-people-carry"></i>
                      Finalizar pedido
                    </button>
                    <div class="dropdown-divider"></div>
                    <button class="dropdown-item" @click="anular" :disabled="!(current.estado != '9')" href="#">
                      <i class="fa fa-archive"></i>
                      Anular Operación
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div style="text-align: center;">
              <h5 class="form-header">
                Pedido Mayoreo
                <span v-if="current.numero != null"> #{{ current.numero }}</span>
              </h5>
              <div class="badge" :class="{
                'badge-success': current.estado == 'A',
                'badge-warning': current.estado == 'B',
                'badge-danger': current.estado == '9',
              }">
                <i class="os-icon os-icon-ui-09"></i>
                <span v-if="current.estado_str">{{ current.estado_str }}</span>
                <span v-if="!current.estado_str">En Proceso</span>
              </div>
            </div>
            <div class="col-12">
              <div class="element-actions">
                <div class="form-header">
                  <button @click="refreshCurrent()" class="btn btn-info">
                    <i class="fas fa-sync"></i>
                  </button>
                  <div class="btn-group">
                    &nbsp;
                    <button aria-expanded="false" aria-haspopup="true" class="btn btn-secondary dropdown-toggle"
                      data-toggle="dropdown" type="button">
                      <i class="fas fa-print"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right">
                      <button class="dropdown-item" @click="imprimirReportePicking()">
                        <i class="fas fa-file-pdf"></i> Imprimir Picking
                      </button>
                      <button class="dropdown-item" @click="imprimir" :disabled="current.estado == 'A'">
                        <i class="fas fa-file-pdf"></i>
                        Imprimir Cotización
                      </button>
                    </div>
                  </div>
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-box" style="padding: 0rem 0.4rem">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-box" style="padding: 1rem 2rem">
            <small v-if="current.errors && current.errors.detail" class="form-text text-danger">{{ current.errors.detail
            }}</small>
            <div @click="isOpenFunction()" style="color: #555555">
              INFORMACIÓN GENERAL &nbsp;
              <i v-if="isOpen" style="font-size: 17px" class="fas fa-toggle-on text-success"></i>
              <i v-if="!isOpen" style="font-size: 17px" class="fas fa-toggle-off text-success"></i>
              <span style="float: right; font-size: 18px; color: #55cf37"><i v-if="isOpen"
                  class="fas fa-chevron-up"></i><i v-if="!isOpen" class="fas fa-chevron-down"></i></span>
            </div>
            <div class="table acordeon" :style="{ maxHeight: isOpen ? '270px' : '0' }">
              <table class="table">
                <thead>
                  <th></th>
                  <th></th>
                </thead>
                <tbody>
                  <tr>
                    <td class="font-weight-bold" style="width: 100px">Tienda</td>
                    <td style="color: #555555">{{ current.tienda.nombre }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Caja</td>
                    <td style="color: #555555">{{ current.caja.caja }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Vendedor</td>
                    <td style="color: #555555">{{ current.vendedor }}</td>
                  </tr>
                  <tr>
                    <td class="font-weight-bold">Fecha</td>
                    <td style="color: #555555">{{ current.fecha }}</td>
                  </tr>
                  <tr v-if="current.super_cliente">
                    <td class="font-weight-bold">Super Cliente</td>
                    <td style="color: #555555">
                      {{ current.super_cliente.codigo }} -
                      {{ current.super_cliente.nombre }} &nbsp;
                      <button style="font-size: 14px; padding: 1.5px" class="btn btn-sm btn-outline-success"
                        @click="abrirModalModificarSuperCliente()">
                        <i class="fas fa-user-edit" style="font-size: 10px;"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="current.cliente">
                    <td class="font-weight-bold">Cliente</td>
                    <td style="color: #555555">
                      {{ current.cliente.nit }} - {{ current.cliente_nombre }} &nbsp;
                      <button style="font-size: 14px; padding: 1.5px" class="btn btn-sm btn-outline-success"
                        @click="abrirModalModificarCliente()">
                        <i class="fas fa-user-edit" style="font-size: 10px;"></i>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="current.super_cliente">
                    <td class="font-weight-bold">Ruta Reparto</td>
                    <td style="color: #555555">{{ current.ruta_reparto.nombre }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <CambiarModalComponent :current="current" :detalle="detalle_linea" :clientes_="clientes_"
              @refresh="refreshCurrent" />
          </div>
        </div>
      </div>
    </div>

    <div class="content-box" style="padding: 0rem 0.4rem">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <div class="col-12">          
                <div class="col-12" style="border: 0.5px solid #d6dbd7">
                  <div style="border-top: 0.5px solid #d6dbd7; padding: 5px" class="row">
                    <div class="col-6">
                      <span style="font-weight: bold">Total:</span>
                    </div>
                    <div class="col-6">
                      <span v-if="current.total" class="text-success" style="font-weight: bold">
                        Q {{ current.total.toFixed(2) }}
                      </span>
                    </div>
                  </div>
                  <div style="border-top: 0.5px solid #d6dbd7; padding: 5px" class="row">
                    <div class="col-6">
                      <span style="font-weight: bold">Pendiente de Pagar:</span>
                    </div>
                    <div class="col-6">
                      <span v-if="current.pendiente_pagar" class="text-success" style="font-weight: bold">
                        Q {{ current.pendiente_pagar.toFixed(2) }}
                      </span>
                    </div>
                  </div>
                  <div style="border-top: 0.5px solid #d6dbd7; padding: 5px" class="row">
                    <div class="col-6">
                      <span style="font-weight: bold">Total de Pagado:</span>
                    </div>
                    <div class="col-6">
                      <span class="text-success" style="font-weight: bold">
                        Q {{ current.total_pagado.toFixed(2) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <br />
                <button type="button" class="btn btn-md btn-success btn-block" @click="showModalAddDetail"
                  v-if="current.estado == 'A'">
                  Agregar Producto &nbsp; <i class="fa fa-plus"></i>
                </button>
              </div>
              <br />
              <h6>Detalle de productos</h6>

              <div class="table-responsive">
                <!-------------------- Tabla de Resultados -------------------->
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="detalle in current.cxcpedidod_set" v-bind:key="detalle.id"
                      @click="openModalOpcionesTabla(detalle)">
                      <td>
                        <div class="value">
                          <span class="font-weight-bold">{{ detalle.producto.sku }}</span>
                        </div>
                        <span>
                          <div class="value">{{ detalle.descripcion }}</div>
                        </span>
                        <div class="value">
                          <small class="font-weight-bold">{{
                            detalle.cantidad_um
                          }}</small>
                          <small class="font-weight-bold">
                            &nbsp;{{ detalle.unidad_medida.nombre }}</small>
                        </div>
                      </td>
                      <td style="width: 100px">
                        <small>
                          <div class="value">
                            Precio: &nbsp;Q{{ detalle.precio }}
                          </div>
                        </small>
                        <small>
                          <div class="value">
                            Total: &nbsp;Q{{ detalle.total }}
                          </div>
                        </small>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <!-------------------- END - Tabla de Resultados -------------------->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div aria-hidden="true" class="modal fade" id="modalAddDetailReqCompra" role="dialog" tabindex="-1"
      data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog modal-md" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Agregar Producto</h5>
            <button @click="cerrarModalDetalle" class="close" type="button">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <form @submit="agregaDetalle">
            <div class="modal-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors && currentDetalle.errors.length > 0,
                        }"></label>
                        <ProductoSelectComponent :current="currentDetalle" @input="refreshUnidadMedida" />
                        <small v-if="currentDetalle.errors" class="form-text text-danger"></small>
                      </div>
                    </div>
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.unidad_medida &&
                            currentDetalle.errors.unidad_medida.length > 0,
                        }">Unidad de Medida</label>
                        <select class="form-control" v-model="currentDetalle.precio_actual">
                          <option v-for="(precio, key) in currentDetalle.producto.lista_precios" :value="precio"
                            :key="key">
                            {{ precio.unidad_medida.nombre }}
                          </option>
                        </select>
                        <small v-if="currentDetalle.errors && currentDetalle.errors.unidad_medida
                          " class="form-text text-danger">{{ currentDetalle.errors.unidad_medida[0] }}</small>
                      </div>
                    </div>
                    <br />
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label v-bind:class="{
                          'text-danger':
                            currentDetalle.errors.cantidad &&
                            currentDetalle.errors.cantidad.length > 0,
                        }">Cantidad en Unidad de Medida</label>
                        <input v-model="currentDetalle.cantidad" class="form-control" placeholder="Cantidad" type="number"
                          style="text-align: center; font-size: 200%" v-bind:class="{
                            'is-invalid':
                              currentDetalle.errors.cantidad &&
                              currentDetalle.errors.cantidad.length > 0,
                          }" />
                        <small v-if="currentDetalle.errors && currentDetalle.errors.cantidad"
                          class="form-text text-danger">{{ currentDetalle.errors.cantidad[0] }}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div style="overflow-y: scroll; max-height: 130px" class="col-md-12"
                  v-if="currentDetalle.producto.sku != null">
                  <div>
                    <table class="table">
                      <thead>
                        <tr>
                          <th>Unidad de Medida</th>
                          <th class="text-right">Cantidad X Precio</th>
                          <th class="text-right" style="width: 100px">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="detalle in currentDetalle.producto.lista_precios" v-bind:key="detalle.id">
                          <td>
                            {{ detalle.unidad_medida.nombre }}
                          </td>
                          <td class="text-right" v-if="currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id ==
                            detalle.unidad_medida.id
                            ">
                            {{ currentDetalle.cantidad }} X Q
                            {{ currentDetalle.precio_actual.precio }}
                          </td>
                          <td class="text-right" v-if="currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id !=
                            detalle.unidad_medida.id
                            ">
                            Q {{ detalle.precio }}
                          </td>
                          <td class="text-right" style="font-weight: bold" v-if="currentDetalle.precio_actual != null &&
                            currentDetalle.precio_actual.unidad_medida.id ==
                            detalle.unidad_medida.id
                            ">
                            Q
                            {{
                              (
                                currentDetalle.precio_actual.precio *
                                currentDetalle.cantidad
                              ).toFixed(2)
                            }}
                          </td>
                          <td style="width: 100px" class="text-right" v-if="currentDetalle.precio_actual != null &&
                              currentDetalle.precio_actual.unidad_medida.id !=
                              detalle.unidad_medida.id
                              ">
                            Q 0.00
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <button class="btn btn-block btn-primary" :disabled="current.estado != 'A'" type="submit">
                    Agregar <i class="fas fa-plus"></i>
                  </button>
                </div>
                <div class="col-6">
                  <button class="btn btn-secondary btn-block" @click="cerrarModalDetalle" type="button">
                    Cerrar <i class="fas fa-door-open"></i>
                  </button>
                </div>
              </div>
              <br />
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Asignación de Ruta</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <SuperClientesSelectComponent :current="current" />
            </div>
            <div class="col-12">
              <div class="form-group">
                <label v-bind:class="{
                  'text-danger': current.errors && current.errors.ruta_reparto,
                }">Ruta Reparto</label>
                <select class="form-control" required v-model="current.ruta_reparto">
                  <option v-for="(det, key) in rutas_reparto" :value="det.id" :key="key">
                    {{ det.id }} -
                    {{ det.nombre }}
                  </option>
                </select>
                <small v-if="current.errors && current.errors.ruta_reparto" class="form-text text-danger">{{
                  current.errors.ruta_reparto[0] }}</small>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
            <button @click="asignar_ruta()" type="button" class="btn btn-primary">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal -->
    <div class="modal fade" id="exampleModal1" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
      aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Opción de linea</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="col-12">
              <button class="btn btn-sm btn-block btn-danger" href="#" @click="deleteDetalle(detalle)">
                Eliminar Linea <i class="fa fa-trash"></i>
              </button>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="current.id">
      <LogModalComponent modulo="cxc" transac="pedidos" :id="current.id" />
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import CommonService from "@/services/commons/CommonService";
import ProductosService from "@/services/catalogos/ProductosService";
import PedidosServices from "@/services/pos/PedidosServices";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import CambiarModalComponent from "@/components/pos/pos_mayoreo/CambiarModalComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import SuperClientesSelectComponent from "@/components/commons/SuperClientesSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import AgregarFormaPagoModalComponent from "@/components/pos/pos_mayoreo/AgregarFormaPagoModalComponent";
import ProductoTiendaMiniTableComponent from "@/components/cat/productos/ProductoTiendaMiniTableComponent";
import LogModalComponent from "@/components/commons/LogModalComponent";

export default {
  components: {
    TiendaSelectComponent,
    ProveedoresSelectComponent,
    ProductoSelectComponent,
    CambiarModalComponent,
    AgregarFormaPagoModalComponent,
    ProductoTiendaMiniTableComponent,
    SuperClientesSelectComponent,
    LogModalComponent,
  },
  data() {
    return {
      isOpen: false,
      detalle: "",
      clientes_: [],
      detalle_linea: {},
      rutas_reparto: [],
      error: [],
      formas_pagos: [],
      current: {
        total_pagado: 0,
        pendiente_pagar: 0,
        id: null,
        tipo: "V",
        total: 0,
        caja: {
          caja: "",
        },
        cliente: {
          nit: "",
          nombre: "",
        },
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        errors: [],
        reqcomprad_set: [],
      },
      tiendas: [],
      proveedores: [],

      productos: [],
      options: [],

      currentDetalle: {
        cantidad: "",
        precio_actual: null,
        producto: {
          sku: null,
          lista_precios: [],
        },
        unidad_medida: null,
        errors: [],
      },
    };
  },
  computed: {},
  mounted() {
    Vue.config.keyCodes.f2 = 113;
    let self = this;
    CommonService.fecha_actual().then((res) => {
      self.current.fecha = res.data.fecha_actual;
    });
    if (this.$route.params.id) {
      self.refreshCurrent();
      ProductosService.fetch({
        page: 1,
        activod: true,
        permitir_compra: true,
      }).then((res) => {
        self.productos = res.data.results;
      });
    }
  },
  methods: {
    isOpenFunction() {
      if (this.isOpen == true) {
        this.isOpen = false;
        return;
      }
      this.isOpen = true;
    },
    abrirModalModificarCliente() {
      let self = this;
      $("#modificarCliente2").modal("show");
    },
    abrirModalModificarSuperCliente() {
      let self = this;
      DynamicService.getById(
        "cat",
        "super-cliente",
        self.current.super_cliente.codigo
      ).then((response) => {
        self.clientes_ = response.data.clientes;
        $("#modificarCliente").modal("show");
      });
    },
    openModalOpcionesTabla(detalle) {
      let self = this;
      this.detalle = detalle;
      if (this.current.estado == "A") {
        $("#exampleModal1").modal("show");
      }
    },
    imprimirXls() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=xls&report_name=cxc/pedidos/Pedido_excel.jrxml&id=${self.id}`
      );
    },
    refreshDataRutasReparto() {
      DynamicService.fetch("cat", "ruta-reparto").then((response) => {
        this.rutas_reparto = response.data.results;
      });
    },
    asignarRutaModal() {
      this.refreshDataRutasReparto();
      $("#exampleModal").modal("show");
    },
    asignar_ruta() {
      let self = this;
      Notifications.alert.confirm(
        "Asignar pedido a Picking",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction(
            "cxc",
            "pedidos",
            self.current.id,
            "asignar_pedido_a_ruta",
            {
              ruta_reparto: self.current.ruta_reparto,
              super_cliente: self.current.super_cliente.codigo,
            }
          )
            .then((reponse) => {
              Notifications.alert.success(
                "El Pedido se ha asignado a una ruta",
                "Realizado Correctamente"
              );
              $("#exampleModal").modal("hide");
              self.refreshCurrent();
            })
            .catch((error) => {
              var errors;
              console.log(error.response.data);
              if (error.response.data.total_pagado) {
                errors = error.response.data.total_pagado;
              }
              Notifications.alert.error("Asignar a Ruta", errors);
            });
        }
      );
    },
    imprimirReportePicking() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/OrdenDespacho.jrxml&Id=${self.id}`
      );
    },
    enviar_picking() {
      let self = this;
      Notifications.alert.confirm(
        "Enviar a Picking",
        "¿Esta Seguro, el pedido no podrá ser abierto despues de realizar esta acción?",
        "",
        function () {
          DynamicService.postAction("cxc", "pedidos", self.current.id, "enviar_a_picking")
            .then((reponse) => {
              Notifications.alert.success(
                "El Pedido se ha colocado en la cola para Despachos",
                "Realizado Correctamente"
              );

              self.refreshCurrent();
              self.imprimirReportePicking();
            })
            .catch((error) => {
              var errors;
              console.log(error.response.data);
              if (error.response.data.total_pagado) {
                errors = error.response.data.total_pagado;
              }
              Notifications.alert.error("Enviar a Picking", errors);
            });
        }
      );
    },
    showModalDescuentoPrecio(detalle) {
      this.detalle_linea.id = detalle.id;
      $("#modificarPrecioLinea").modal();
      $("#exampleModal1").modal("hide");
    },
    showModalDescuentoSubTotal(detalle) {
      this.detalle_linea.id = detalle.id;
      $("#modificarPrecioSubtotal").modal();
      $("#exampleModal1").modal("hide");
    },
    facturarPedido(current) {
      let self = this;
      Notifications.alert.confirm("Facturar Pedido", "¿Esta Seguro?", "", function () {
        DynamicService.postAction("cxc", "pedidos", current.id, "facturar")
          .then((reponse) => {
            Notifications.alert.success("Facturar Pedido", "Realizado Correctamente");
            self.refreshCurrent();
          })
          .catch((error) => {
            var errors;
            if (error.response.data.total_pagado) {
              errors = error.response.data.total_pagado;
            }
            Notifications.alert.error("Facturar Pedido", errors);
          });
      });
    },
    cerrarModalDetalle() {
      if (this.currentDetalle.producto) {
        this.currentDetalle.producto.lista_precios = "";
        this.currentDetalle.producto = "";
        this.currentDetalle.cantidad = "";
      }
      $("#modalAddDetailReqCompra").modal("hide");
    },
    showModalFormaPago() {
      let self = this;
      DynamicService.fetch("cat", "forma-pago").then((response) => {
        self.formas_pagos = response.data.results;
        $("#aggFormaPago").modal();
      });
    },
    generarCotizacion(current) {
      let self = this;
      DynamicService.postAction("cxc", "pedidos", current.id, "generar_cotizacion").then(
        (response) => {
          Notifications.alert.success("Generar Cotizacíon", "¡Realizado con exito!");
          self.$router.push({
            name: "pos-cotizaciones-editar",
            params: { id: self.current.id },
          });
        }
      );
    },
    refreshUnidadMedida() {
      let self = this;
      if (self.currentDetalle.producto == null) {
        self.currentDetalle.producto = {
          lista_precios: [],
        };
        return;
      }
      if (self.currentDetalle.producto.sku == null) {
        self.currentDetalle.producto["lista_precios"] = [];
        return;
      }
      DynamicService.getByIdParams("cat", "productos", self.currentDetalle.producto.sku, {
        tienda: self.current.tienda.codigo,
      }).then((response) => {
        console.log(response.data);
        self.currentDetalle.producto = response.data;
        if (self.currentDetalle.producto.lista_precios.length > 0) {
          self.currentDetalle.precio_actual =
            self.currentDetalle.producto.lista_precios[0];
        } else {
          self.currentDetalle.precio_actual = null;
        }
      });
    },

    refreshExtrasProductos() {
      let self = this;
    },

    refreshCurrent() {
      let self = this;
      PedidosServices.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
        self.current.vendedor = response.data.vendedor.name;
        self.current.fecha = self.customFormatterInverted(self.current.fecha);
        self.current.errors = [];
        self.currentDetalle.errors = [];
        self.currentDetalle.cantidad = "";
      });
    },

    customFormatter(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    customFormatterInverted(date) {
      var d = date.split("/");
      var str_d = d[2] + "-" + d[1] + "-" + d[0];
      return moment(str_d).format("YYYY-MM-DD");
    },

    showModalAddDetail() {
      $("#modalAddDetailReqCompra").modal();
    },
    agregaDetalle(e) {
      e.preventDefault();
      let self = this;
      let det = Object.assign({}, self.currentDetalle);
      var _params = {
        producto: det.producto.sku,
        cantidad: det.cantidad,
      };
      if (det.precio_actual) {
        _params["unidad_medida"] = det.precio_actual.unidad_medida.id;
      }

      PedidosServices.agregar_detalle_um(self.current.id, _params)
        .then((response) => {
          $("#modalAddDetailReqCompra").modal("hide");
          self.refreshCurrent();
          if (self.currentDetalle.producto) {
            self.currentDetalle.producto.lista_precios = "";
            self.currentDetalle.producto = "";
            self.currentDetalle.cantidad = "";
          }
        })
        .catch((error) => {
          var errors;
          if (error.response.data.detail) {
            errors = error.response.data.detail;
          } else {
            let _errors = error.response.data;
            errors = "";
            for (var propertyName in _errors) {
              errors += " " + `${propertyName} = ${_errors[propertyName]}`;
            }
          }
          Notifications.alert.error("Agregar Detalle", errors);
        });
    },

    deleteDetalle(detalle) {
      let self = this;
      $("#exampleModal1").modal("hide");
      Notifications.alert.confirm(
        "Pedido",
        "¿Esta seguro de eliminar el registro?",
        "Si Eliminar",
        function () {
          PedidosServices.eliminar_detalle(detalle.pedido_e, {
            id: detalle.id,
          })
            .then((response) => {
              Notifications.alert.success("Pedido", "Se ha eliminado la Información.");
              self.refreshCurrent();
            })
            .catch((error) => {
              self.current.errors = error.response.data;
            });
        }
      );
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Pedido",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Abrir Transaccion", error.response.data.detail);
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          PedidosServices.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success("Pedido", "Se ha cerrado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Cerrar Transaccion", error.response.data.detail);
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Pedido",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          PedidosServices.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success("Pedido", "Se ha anulado la transaccion.");
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error("Anular Transaccion", error.response.data.detail);
            });
        }
      );
    },
    imprimir() {
      let self = this;
      PedidosServices.pdf(self.current.id)
        .then((response) => {
          window.open(response.data.output);
        })
        .catch((error) => {
          Notifications.alert.error(
            "No se ha podido realizar la acción",
            error.response.data.detail
          );
        });
    },
    imprimirDevoluciones() {
      let self = this;
      self.id = self.current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/pedidos/Devolucion_ProductoND.jrxml&Id=${self.id}`
      );
    },
  },
};
</script>
